const ApplySequenceCssClasses = function (me) {
    const systemMessages = me.context.querySelectorAll('.system_message');

    // if (systemMessages.length) {
    //     systemMessages.forEach((message, index) => {
    //         const messageText = message.querySelector('.apexchat_rd_msg_text');
    //         const timer = message.querySelector('.apexchat_rd_timer_span');

    //         if (messageText) {
    //             const parentWidth = message.offsetWidth; // The `.system_message` itself
    //             const textWidth = messageText.scrollWidth; // Get actual content width
    //             const textHeight = messageText.scrollHeight; // Get actual content width
    //             const maxWidth = parentWidth - (80 * 2); // Parent width - 152px (76px timer on both sides)
    //             if (textWidth <= maxWidth) {
    //                 messageText.style.margin = "0 auto"; // Center align
    //                 message.classList.add("timer_center");
    //                 message.classList.remove("content_left");
    //                 message.classList.remove("content_full_width");

    //             } else if (textHeight > 38) {
    //                 message.classList.add("content_full_width");
    //                 message.classList.remove("content_left");
    //                 message.classList.remove("timer_center");
    //             } else {
    //                 messageText.style.margin = ""; // Default left align
    //                 message.classList.add("content_left");
    //                 message.classList.remove("timer_center");
    //                 message.classList.remove("content_full_width");
    //             }
    //         }

    //         // Find the next message element
    //         const nextMessage = systemMessages[index + 1];

    //         if (nextMessage) {
    //             if (nextMessage.classList.contains("apexchat_message_left")) {
    //                 message.classList.add("timer_right");
    //                 message.classList.remove("timer_left");
    //             } else if (nextMessage.classList.contains("apexchat_message_right")) {
    //                 message.classList.add("timer_left");
    //                 message.classList.remove("timer_right");
    //             }
    //         }
    //     });
    // }

    const messages = me.context.querySelectorAll(
        '.apexchat_message_left:not(.system_message), .apexchat_message_right:not(.system_message)'
    );
    // Loop through all the messages
    messages.forEach((message, index) => {
        const isLeft = message.classList.contains('apexchat_message_left');
        const isRight = message.classList.contains('apexchat_message_right');

        // Remove sequence classes if they already exist
        message.classList.remove('message_sequence_start', 'message_sequence_end');

        // Check for left group
        if (isLeft) {
            // Check if it's the first left element
            if (index === 0 || messages[index - 1].classList.contains('apexchat_message_right')) {
                message.classList.add('message_sequence_start');
            }

            // Check if it's the last left element or the next is a right element
            if (index === messages.length - 1 || messages[index + 1].classList.contains('apexchat_message_right')) {
                message.classList.add('message_sequence_end');
            }
        }

        // Check for right group
        if (isRight) {
            // If it's the only right element, add both sequence classes
            if (
                (index === 0 || messages[index - 1].classList.contains('apexchat_message_left')) &&
                (index === messages.length - 1 || messages[index + 1].classList.contains('apexchat_message_left'))
            ) {
                message.classList.add('message_sequence_start', 'message_sequence_end');
            } else {
                // For the first right element in a group, add "message_sequence_start"
                if (index === 0 || messages[index - 1].classList.contains('apexchat_message_left')) {
                    message.classList.add('message_sequence_start');
                }
                // For the last right element in a group, add "message_sequence_end"
                if (index === messages.length - 1 || messages[index + 1].classList.contains('apexchat_message_left')) {
                    message.classList.add('message_sequence_end');
                }
            }
        }
    });
};

export default ApplySequenceCssClasses;
